import React from 'react';
import CoachingConstants from 'coaching/CoachingConstants';
import Link from 'components/Link';

export default function NoCoachAvailabilityNullState() {
  return (
    <>
      It looks like your coach has no upcoming availabilities.{' '}
      <Link
        target="_blank"
        href={`${CoachingConstants.COACHING_HELP_FORM_ROUTE}?request=c_new_session`}
        data-test="null-state-contact-us-link">
        Contact us{' '}
      </Link>
      and we’ll help you book your session.
    </>
  );
}
